import {assign} from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import {nextStep, isLastStep} from 'utils/step_utils'
import {EUR} from 'utils/currency'
import i18n from 'i18n/config'

const stepName  = 'tourcmsPackStep'

const setError = assign({error: i18n.t('validations:events_fetch_error')})
const setComponents = assign({components: (ctx, e) => e.data})
const setDefaultComponentSelections = assign({component_selections: (ctx, e) => {
  let newComponenSelections = {...ctx.component_selections}

  e.data.forEach((componentData) => {
    newComponenSelections[componentData.tour_id] = {
      product_id: componentData.product_id,
      channel_id: componentData.channel_id,
      tour_id: componentData.tour_id,
      component_key: componentData.components[0].component_key,
      component: componentData.components[0]
    }
  })

  return newComponenSelections
}})
const setComponentSelection = assign({component_selections: (ctx, e) => {
  let newSelection = {...ctx.component_selections}

  newSelection[e.tour_id] = {
    product_id: e.product_id,
    channel_id: e.channel_id,
    tour_id: e.tour_id,
    component_key: e.component.component_key,
    component: e.component
  }

  return newSelection
}})
const cleanError = assign({error: null})

const cleanComponentSelections = assign({component_selections: (ctx, e) => {
  return Object.fromEntries(
    Object.keys(ctx.component_selections).map(key => [key, null])
  )
}})

const initializePriceSummary = assign({priceSummary: ({priceSummary, component_selections}) => {
  const totalPrice = Object.values(component_selections).reduce((acc, cur) => {
    return parseFloat(cur.component.total_price) + acc
  }, 0)

  return Object.assign(priceSummary, {
    tourcmsComponentStep: {
      base_price: EUR(totalPrice),
      discount: EUR(0),
      additional_fee: EUR(0),
      total_price: EUR(totalPrice)
    }
  })
}})

const setPriceSummary = assign({priceSummary: (ctx, e) => {
  let newSelection = {...ctx.component_selections}

  newSelection[e.tour_id] = {
    product_id: e.product_id,
    channel_id: e.channel_id,
    tour_id: e.tour_id,
    component_key: e.component.component_key,
    component: e.component
  }

  const totalPrice = Object.values(newSelection).reduce((acc, cur) => {
    return parseFloat(cur.component.total_price) + acc
  }, 0)

  return Object.assign(ctx.priceSummary, {
    tourcmsComponentStep: {
      base_price: EUR(totalPrice),
      discount: EUR(0),
      additional_fee: EUR(0),
      total_price: EUR(totalPrice)
    }
  })

  return Object.assign(priceSummary, {
    tourcmsComponentStep: {
      base_price: EUR(0),
      discount: EUR(0),
      additional_fee: EUR(0),
      total_price: EUR(0)
    }
  })
}})

const componentSelected = (ctx) => {
  const isComponentsArray = Object.values(ctx.component_selections).map((component) => {
    if (component && component.component_key) {
      return true
    } else {
      return false
    }
  })

  return isComponentsArray.every((isComponent) => isComponent == true)
}

const setValidationError = assign({error: i18n.t('validations:component_required')})

const fetchComponents = (ctx) => {
  const rates = ctx.tickets.reduce((accum, current) => {
    if (current.qty > 0) {
      return {...accum, [current.id]: current.qty}
    } else {
      return {...accum}
    }
  }, {})

  return new ApiFetcher({
    key: 'tourcms_components',
    endpoint: ctx.endpoints.tourcms_components,
    query: {qs: JSON.stringify({date: ctx.day, rates: rates})}
  }).call()
}

const componentsAvailable = (ctx, e) => {
  const allComponentsAvailable = Object.values(e.data).reduce((acc, cur) => {
    if (acc == false) {
      return false
    }

    if (cur.components && cur.components.length > 0) {
      return true
    }
  }, true)

  return allComponentsAvailable
}

const tourcmsPackStep = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'fetchingComponents',
          actions: [cleanError, cleanComponentSelections, 'startSpinner']
        }},
      },
      fetchingComponents: {
        invoke: {
          src: fetchComponents,
          onDone: [
            // {
            //   target: '#purchase.' + nextStep(config, stepName),
            //   actions: [setEvent, 'stopSpinner'],
            //   cond: eventsAvailable
            // },
            {
              target: 'initializePriceSummary',
              cond: componentsAvailable,
              actions: ['stopSpinner', setComponents, setDefaultComponentSelections]
            },
            {
              target: 'unavailableComponents',
              actions: ['stopSpinner']
            },
          ],
          onError: {
            target: '#purchase.error',
            actions: [setError, 'stopSpinner']
          }
        },
      },
      initializePriceSummary: {
        on: {'': {
          target: 'waitingComponentPick',
          actions: [initializePriceSummary]
        }},
      },
      unavailableComponents: {},
      waitingComponentPick: {}
    },
    on: {
      COMPONENT_SELECTION: {
        // target: '#purchase.reserving',
        actions: [setComponentSelection, setPriceSummary, cleanError]
      },
      NEXT_STEP_CLICK: [
        {
          target: isLastStep(config, 'tourcmsPackStep') ? '#purchase.reserving' : '#purchase.' + nextStep(config, 'tourcmsPackStep'),
          cond: componentSelected
        },
        {
          actions: setValidationError
        }
      ],
      RESERVATION_REQUEST: [
        {
          target: '#purchase.reserving',
          cond: componentSelected
        },
        {
          actions: setValidationError
        }
      ],
    }
  }
}

export default tourcmsPackStep
